import { render } from "./PraticheStalloIncall.vue?vue&type=template&id=6a92e3cc&scoped=true"
import script from "./PraticheStalloIncall.vue?vue&type=script&lang=js"
export * from "./PraticheStalloIncall.vue?vue&type=script&lang=js"

import "./PraticheStalloIncall.vue?vue&type=style&index=0&id=6a92e3cc&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a92e3cc"]])

export default __exports__